// @flow
import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import MediaObject from 'components/MediaObject.jsx';
import MenuItem from 'components/MenuItem.jsx';
import Text from 'components/Text.jsx';

import type { MessageFilterType } from 'reducers/roleBasedMessagingSearch';

export type Props = {
  filter: MessageFilterType,
  imageSrc: *,
  isSelected: boolean,
  orgUuid: ?string,
  groupUuid: ?string,
  onClick: Function,
  dataTestSelector: ?string,
  data: ReactApolloData<TargetFilterMenuItemQuery>,
};

class TargetFilterMenuItem extends React.Component<Props, *> {
  render() {
    const { data, filter, imageSrc, isSelected, onClick } = this.props;
    const countIsLoaded = data && !!data.countRecipients;
    const filterText = filter.value.id === 'all' ? 'Everyone' : filter.value.label;

    return (
      <MenuItem key={filter.value.id} onClick={onClick}>
        <MediaObject center figure="right">
          <MediaObject center gutter="xsmall">
            <Image src={imageSrc} width={20} />
            <Text
              size="xsmall"
              color="pitch"
              data-test-selector={`${this.props.dataTestSelector || ''}-${filterText}`}>
              {filterText}
              {countIsLoaded && (
                <Text size="xsmall" color="eclipse">
                  {'  '}({data.countRecipients.count})
                </Text>
              )}
            </Text>
          </MediaObject>
          {isSelected ? <Glyph solo name="check" size="medium" color="brand" /> : <span />}
        </MediaObject>
      </MenuItem>
    );
  }
}

const withCount = graphql(
  gql`
    query TargetFilterMenuItem($input: RecipientInput!) {
      countRecipients(input: $input) {
        count
      }
    }
  `,
  {
    skip: ({ orgUuid, groupUuid }) => !orgUuid && !groupUuid,
    options: ({ orgUuid, groupUuid, filter }) => {
      const isOrg = !!orgUuid;
      const type = isOrg ? 'organization' : 'group';
      const uuid = isOrg ? orgUuid : groupUuid;
      const filters = filter.value.id === 'all' ? [] : [{ [filter.type]: [filter.value.id] }];
      return {
        variables: { input: { type, uuid, filters } },
      };
    },
  }
);

export { TargetFilterMenuItem };

export default withCount(TargetFilterMenuItem);
